import { useQuery } from '@tanstack/react-query'
import { photosService } from '@/api/services/photos.service'
import { queryKeys } from '@/api/query-keys'

export function useCandidAutoTagging(candidId: string | null) {
  return useQuery({
    queryKey: queryKeys.photos.candidAutoTagging(candidId),
    queryFn: () => photosService.getCandidAutoTagging(candidId!),
    enabled: !!candidId,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
